import NavigationLink from '@/components/NavigationLink';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { MouseEventHandler } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  dense: {
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
  },
  icon: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  selected: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold as CSSProperties['fontWeight'],
  },
}));

interface NavigationItemProps {
  text: string;
  icon: JSX.Element;
  href: string;
  selected?: boolean;
  onClick?: MouseEventHandler;
}

export default function NavigationItem({
  text,
  icon,
  href,
  selected = false,
  onClick = () => null,
}: NavigationItemProps): JSX.Element {
  const classes = useStyles();

  return (
    <ListItem
      classes={{
        dense: classes.dense,
        selected: classes.selected,
      }}
      button
      component={NavigationLink}
      href={href}
      selected={selected}
      color="inherit"
      onClick={onClick}
    >
      <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
      <ListItemText primary={text} />
    </ListItem>
  );
}
